import { useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

export const StepProgramaDI2 = ({
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [datosProgramaDI, setDatosProgramaDI] = useState(fullFormDataRI?.programaDI2 ?? {});
  const [combosRI, setCombosRI] = useState();

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const handleSubmit = () => {
    updateFormData('programaDI2', datosProgramaDI, parsedInputsGroup.flatMap((x) => x.inputs));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaDI((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const parsedInputsGroup = useMemo(() => {

    if (!combosRI) return inputsGroups;

    return inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName) {
          input.options = combosRI[input.name];
        }
        switch (input.name) {
          case 'justificacionNadaPorBoca':
            if (!datosProgramaDI?.nadaPorBoca) handleChange(input.name);
            input.hidden = !datosProgramaDI?.nadaPorBoca;
            input.required = !!datosProgramaDI?.nadaPorBoca;
            break;
          case 'idComboRIValorEvaluacionFonoaudiologica':
            input.options = input.options.map((o) => ({ label: o.displayName, value: o.id }));
            break;
          case 'idComboRIValorProtesis':
            const denticionTotalId = combosRI.idComboRIValorDenticion.find((x) => x.displayName.includes('Total'))?.id;
            const denticionParcialId = combosRI.idComboRIValorDenticion.find((x) => x.displayName.includes('Parcial'))?.id;
            input.required = datosProgramaDI.idComboRIValorDenticion === denticionTotalId || datosProgramaDI.idComboRIValorDenticion === denticionParcialId;
            break;
          case 'idComboRIValorLiquidosEspesadosConConsistencia':
            const liquidosEspesadosId = combosRI.idComboRIValorHidratacion.find((x) => x.displayName.includes('espesados con consistencia'))?.id;
            const hidratacionEsEspesados = datosProgramaDI.idComboRIValorHidratacion === liquidosEspesadosId;
            input.required = hidratacionEsEspesados;
            input.disabled = !hidratacionEsEspesados;
            if (input.disabled) handleChange(input.name);
            break;
          default:
            break;
        }
        return input;
      })
    }));
  }, [combosRI, datosProgramaDI.idComboRIValorHidratacion, datosProgramaDI.idComboRIValorDenticion, datosProgramaDI?.nadaPorBoca]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaDI, setDataSubmissionCallback, parsedInputsGroup]);

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid container>
            {group.inputs.
              filter((input) => !input.hidden).
              map((input) => {
                return (
                  <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={datosProgramaDI[input.name]}
                    row={input.type === 'multiple_boolean'} />);


              })}
          </Grid>
        </div>
      )}
    </div>);

};

const inputsGroups = [
  // {
  //     groupName: 'DI - Fonoaudiologo',
  //     inputs: [
  //         // {
  //         //     displayName: 'Actividad motora y postura corporal al momento de alimentarse',
  //         //     name: 'actividadMotoraAlAlimentarse',
  //         //     required: true,
  //         //     type: 'boolean'
  //         // },
  //         // {
  //         //     displayName: 'Control cefálico',
  //         //     name: 'controlCefalico',
  //         //     required: true,
  //         //     type: 'boolean'
  //         // },
  //         // {
  //         //     displayName: 'Control postural',
  //         //     name: 'idComboRIValorControlPostural',
  //         //     comboName: 'Control postural',
  //         //     required: true,
  //         //     type: 'select'
  //         // },
  //         // {
  //         //     displayName: 'Dentición',
  //         //     name: 'idComboRIValorDenticion',
  //         //     comboName: 'Dentición',
  //         //     required: true,
  //         //     type: 'select'
  //         // },
  //         // {
  //         //     displayName: 'Prótesis',
  //         //     name: 'idComboRIValorProtesis',
  //         //     comboName: 'Prótesis',
  //         //     required: true,
  //         //     type: 'select'
  //         // },
  //         // {
  //         //     displayName: 'Evaluación Fonoaudilogía',
  //         //     name: 'idComboRIValorEvaluacionFonoaudiologica',
  //         //     comboName: 'Evaluacion Fonoaudiología',
  //         //     required: true,
  //         //     type: 'multiple_boolean'
  //         // },
  //         // {
  //         //     displayName: 'Ingresa a Módulo de Disfagia',
  //         //     name: 'idComboRIValorModuloDisfagia',
  //         //     comboName: 'Ingresa a Módulo de Disfagia',
  //         //     required: true,
  //         //     type: 'select'
  //         // },
  //     ]
  // },
  {
    groupName: 'Indicación',
    inputs: [
      {
        name: 'nadaPorBoca',
        displayName: 'Nada por boca',
        required: true,
        type: 'boolean'
      },
      {
        name: "justificacionNadaPorBoca",
        displayName: "Justificación",
        type: "long_string",
        maxLength: 250,
        required: false
      },
      {
        displayName: 'Hidratación',
        name: 'idComboRIValorHidratacion',
        comboName: 'INDICACIONES LIQUIDOS',
        required: true,
        type: 'select'
      }
      // {
      //     displayName: 'Líquidos espesados con consistencia',
      //     name: 'idComboRIValorLiquidosEspesadosConConsistencia',
      //     comboName: 'Líquidos espesados con consistencia',
      //     required: true,
      //     type: 'select'
      // },
      // {
      //     displayName: 'Requiere nutricion Enteral',
      //     name: 'requiereNutricionEnteral',
      //     required: true,
      //     type: 'boolean'
      // },
    ]
  }];